import React, { useState } from 'react';
import { Form, FormFeedback, FormGroup, Input, Label, Row, InputGroup, InputGroupAddon, InputGroupText } from 'reactstrap';
import "react-datetime/css/react-datetime.css";
import { cedimi } from '../../constant/globalConstantsTypeClients'
import Select from 'react-select';
import { WhatsApp } from '@mui/icons-material';


export const FormDoctor = (props) => {

    const {

        specialties, id_specialty, name, professional_license,
        phone, address, email, handleInputChange,

        nameInputs,
        addSpecialty, name_specialty, validaciones, isCommercialPartner,
        // ? 
        code, username, password_microsite, generateRandomPassword, id_seller,
        listSellers, whatsapp_doctor, handleWhatsappDoctorChange, validateWhatsappDoctor

    } = props;
    const {
        id_specialty: validacionIdSpecialty,
        name: validacionName,
        name_specialty: validacionNameSpecialty,
        email_validate: email_validate,
        whatsapp_doctor_validate: whatsapp_doctor_validate

    } = validaciones;
    const {
        name: nameInput,
        id_specialty: id_specialtyInput,
        professional_license: professional_licenseInput,
        phone: phoneInput,
        address: addressInput,
        email: emailInput,
        code: codeInput,
        username: Inputusername,
        password_microsite: password_micrositeInput,
        whatsapp_doctor: WhatsappInput
        

        // isCommercialPartner: isCommercialPartner
    } = nameInputs;

    // ////console.log(validacionIdSpecialty);
    // ////console.log("pasa aqui");
    // ////console.log(validaciones1);
    // ////console.log("pasa aqui");

    let _typeClient = localStorage.getItem('url_helen');
    const [showPassword, setShowPassword] = useState(false);

    const toggleShowPassword = () => {
        setShowPassword(prev => !prev);
    };

    const specialtyOptions = specialties.map(x => ({
        value: x.id_specialty,
        label: x.name
    }));

    const sellerOptions = listSellers.map(x => ({
        value: x.id_seller,
        label: x.name
    }));

    console.log("🫒 sellerOptions", sellerOptions);

    return (
        <div className="form-section" >
            <h6 className="section-title">
                <i className="fa fa-user"></i>
                Información General
            </h6>

            <small className="section-warning-absolute">
                <i className="fa fa-exclamation-circle me-1"></i>&nbsp;
                Complete los campos requeridos
            </small>

            <Form role="form">
                <Row>
                    <FormGroup className="mb-3 col-12 col-md-6 col-lg-4 p-1">
                        <Label className="label-admision">Nombre del médico <span className='f-16' style={{ color: "#0079C7" }}>*</span></Label>
                        <Input
                            placeholder="Nombre del médico"
                            type="text"
                            name={nameInput}
                            value={name}
                            required={true}
                            autoComplete="nope"
                            onChange={handleInputChange}
                            invalid={validacionName}
                            className="input-admision"
                        />
                        <FormFeedback>El nombre debe tener 3 o más caracteres</FormFeedback>
                    </FormGroup>
                    <FormGroup className="mb-3 col-12 col-md-6 col-lg-4 p-1">
                        <Label className="label-admision">Especialidad</Label>

                        <Select
                            name="id_specialty"
                            value={
                                specialtyOptions.find(
                                    option => option.value === id_specialty
                                ) || null
                            }
                            isClearable
                            placeholder="Selecciona una especialidad"
                            options={specialtyOptions}
                            onChange={(selected) =>
                                handleInputChange({
                                    target: {
                                        name: "id_specialty",
                                        value: selected ? selected.value : 0
                                    }
                                })
                            }
                            menuPortalTarget={document.body}
                            styles={{ menuPortal: base => ({ ...base, zIndex: 9999999 }) }}
                            classNamePrefix="input-admision"
                        />
                    </FormGroup>

                    <FormGroup className={`mb-3 col-12 col-md-6 col-lg-4 p-1 ${(addSpecialty !== undefined && id_specialty === "new") ? "" : "d-none"}`}>
                        <Label className="label-admision">Nombre de la nueva especialidad <span className='f-16' style={{ color: "#0079C7" }}>*</span></Label>
                        <Input
                            // placeholder="Nueva especialidad"
                            type="text"
                            name="name_specialty"
                            className="input-admision"
                            value={name_specialty}
                            required={false}
                            autoComplete="off"
                            onChange={handleInputChange}
                            invalid={validacionNameSpecialty}
                        />
                        <FormFeedback>La especialidad debe tener 3 o más caracteres</FormFeedback>
                    </FormGroup>
                    <FormGroup className="mb-3 col-12 col-md-6 col-lg-4 p-1">
                        <Label className="label-admision" col-form-label>Licencia profesional </Label>
                        <Input
                            // placeholder="Licencia profesional"
                            type="text"
                            name={professional_licenseInput}
                            value={professional_license}
                            autoComplete="off"
                            onChange={handleInputChange}
                            className="input-admision"

                        />
                    </FormGroup>
                    <FormGroup className="mb-3 col-12 col-md-6 col-lg-4 p-1">
                        <Label className="label-admision">Télefono </Label>
                        <Input
                            // placeholder="Télefono"
                            type="text"
                            name={phoneInput}
                            value={phone}
                            autoComplete="off"
                            onChange={handleInputChange}
                            className="input-admision"

                        />
                    </FormGroup>

                    <FormGroup className="mb-3 col-12 col-md-6 col-lg-4 p-1">
                        <Label className="label-admision">Dirección </Label>
                        <Input
                            type="text"
                            name={addressInput}
                            value={address}
                            autoComplete="off"
                            onChange={handleInputChange}
                            className="input-admision"

                        />
                    </FormGroup>


                    <FormGroup className="mb-3 col-12 col-md-6 col-lg-4 p-1">
                        <Label className="label-admision">Vendedor(a) </Label>
                        <Select
                            name="id_seller"
                            value={
                                listSellers.find(
                                    option => option.value === id_seller
                                ) || null
                            }
                            isClearable
                            placeholder="Selecciona un vendedor"
                            options={listSellers}
                            onChange={(selected) =>
                                handleInputChange({
                                    target: {
                                        name: "id_seller",
                                        value: selected ? selected.value : 0
                                    }
                                })
                            }
                            menuPortalTarget={document.body}
                            styles={{ menuPortal: base => ({ ...base, zIndex: 9999999 }) }}
                            classNamePrefix="input-admision"
                        />

                    </FormGroup>

                    <FormGroup className="mb-3 col-12 col-md-10 col-lg-5 p-1">
                        <Label className="label-admision">Correo electrónico:&nbsp; </Label>
                        <span style={{ fontSize: "11px" }} className='txt-secondary'>En caso de requerir más de un correo separar con el símbolo ,</span>

                        <Input
                            type="email"
                            name={emailInput}
                            value={email}
                            autoComplete="new-email"
                            onChange={handleInputChange}
                            className="input-admision"
                            invalid={email_validate}

                        />

                    </FormGroup>

                    <FormGroup className="mb-3 col-12 col-md-10 col-lg-4 p-1">
                        <Label className="label-admision">No. WhatsApp:&nbsp; </Label>
                        <span style={{ fontSize: "11px" }} className='txt-secondary'>
                            En caso de más de un teléfono, sepárelos con ","
                        </span>

                        <Input
                            type="text"
                            name={WhatsappInput}
                            value={whatsapp_doctor}
                            autoComplete="off"
                            onChange={(e) => {
                                handleWhatsappDoctorChange(e);
                                validateWhatsappDoctor();
                            }}
                            onBlur={validateWhatsappDoctor}
                            className="input-admision"
                            invalid={whatsapp_doctor_validate}
                        />

                        <FormFeedback>
                            Cada número debe tener exactamente 10 dígitos y separarse por coma.
                        </FormFeedback>
                    </FormGroup>

                    <FormGroup className="mb-3 col-12 col-md-2 col-lg-3">
                        <Label className="label-admision">¿Cuenta con Convenio?</Label>
                        <br />
                        <Label className="switch">
                            <Input
                                type="checkbox"
                                name="isCommercialPartner"
                                onChange={handleInputChange}
                                checked={isCommercialPartner}
                            />
                            <span className="slider round"></span>
                        </Label>
                    </FormGroup>

                    {isCommercialPartner && (
                        <FormGroup className="mb-3 col-12 col-md-4 col-lg-4">
                            {_typeClient === cedimi ? (
                                <Label className="label-admision">No. Colegiado</Label>
                            ) : (
                                <Label className="label-admision">Código</Label>
                            )}

                            <Input
                                type="text"
                                name="code"
                                value={code}
                                autoComplete="nope"
                                onChange={handleInputChange}
                                className="input-admision"
                            />
                        </FormGroup>
                    )}

                    {isCommercialPartner && (
                        <>
                            <FormGroup className="mb-3 col-12 col-md-4 col-lg-4">
                                <Label className="label-admision"> Usuario</Label>
                                <Input
                                    type="text"
                                    name={Inputusername}
                                    value={username}
                                    autoComplete="off"
                                    onChange={handleInputChange}
                                    className="input-admision"
                                />
                            </FormGroup>

                            <FormGroup className="mb-3 col-12 col-md-4 col-lg-4">
                                <Label className="label-admision">Contraseña de Micrositio</Label>

                                <InputGroup>
        
                                    <Input
                                        type={showPassword ? 'text' : 'password'}
                                        className="input-admision"
                                        name="password_microsite"
                                        value={password_microsite}
                                        onChange={handleInputChange}
                                        placeholder="Contraseña"
                                        autoComplete="new-password"
                                    />
                                    <InputGroupAddon addonType="append">
                                        <InputGroupText onClick={toggleShowPassword} style={{ cursor: "pointer" }}>
                                            <span className={`fa fa-eye${showPassword ? "-slash" : ""}`} />
                                        </InputGroupText>
                                    </InputGroupAddon>

                                    <InputGroupAddon addonType="append">
                                        <InputGroupText onClick={generateRandomPassword} style={{ cursor: "pointer" }}>
                                            <span className={`fa fa-lock`} />
                                        </InputGroupText>
                                    </InputGroupAddon>
                                </InputGroup>
                            </FormGroup>
                        </>
                    )}



                </Row>

            </Form>
        </div>

    )
}
